import { jsxs as O, jsx as o } from "react/jsx-runtime";
import { selectIconColor as y } from "./index.es672.js";
import S from "classnames";
import { forwardRef as U, useState as _, useCallback as h, cloneElement as N } from "react";
import t from "./index.es673.js";
import { getButtonAriaLabel as j } from "./index.es675.js";
import { ButtonLoadingIndication as v } from "./index.es676.js";
import { UtilityChevronIcon as A } from "./index.es422.js";
const E = "button-component", G = U(
  ({
    variant: r = "primary-brand",
    fullWidth: T = !1,
    size: B = "default",
    children: m,
    LeftIcon: d,
    RightIcon: f,
    disabled: a,
    chevron: c,
    alignment: x,
    testId: l,
    onMouseEnter: n,
    onMouseLeave: i,
    isLoading: e = !1,
    ...$
  }, g) => {
    const [p, u] = _(!1), b = {
      color: a ? "outline" : r === "secondary-gray" ? "gray" : "outline",
      outline: y(r, p, a)
    }, w = h(
      (s) => {
        n == null || n(s), u(!0);
      },
      [n]
    ), C = h(
      (s) => {
        i == null || i(s), u(!1);
      },
      [i]
    );
    return /* @__PURE__ */ O(
      "button",
      {
        ref: g,
        className: S(t.button, [t[`button--alignment-${x}`]], {
          [t["button--full-width"]]: T,
          [t.loading]: e
        }),
        disabled: a,
        "data-testid": l,
        onMouseEnter: w,
        onMouseLeave: C,
        "data-pl-size": B,
        "data-pl-variant": r,
        "aria-label": j(m, e),
        ...$,
        children: [
          /* @__PURE__ */ o(v, { isLoading: e, variant: r, testId: l }),
          d && !e && /* @__PURE__ */ o("div", { className: t.leftIcon, "data-testid": "left-icon", children: N(d, b) }),
          /* @__PURE__ */ o("span", { "data-testid": `${l}-value`, className: t.buttonText, children: m }),
          !!f && !e && /* @__PURE__ */ o("div", { className: t.rightIcon, "data-testid": "right-icon", children: N(f, b) }),
          c && /* @__PURE__ */ o(
            "div",
            {
              className: t.chevron,
              "data-testid": `${l}-chevron-${c.direction}`,
              "data-type": "chevron",
              children: /* @__PURE__ */ o(
                A,
                {
                  type: "bold",
                  direction: c.direction || "down",
                  outline: y(r, p, a)
                }
              )
            }
          )
        ]
      }
    );
  }
);
export {
  E as BUTTON_DEFAULT_TEST_ID,
  G as Button
};
//# sourceMappingURL=index.es11.js.map
